import { actionCreator,
  checkHttpStatus,
  CLEARINGHOUSE_STATUS_ACTIVATION,
  clearingHouseActionTypes,
  DELETE_CLEARINGHOUSE_API,
  GET_CLEARINGHOUSE_DETAILS_API,
  GET_CLEARINGHOUSE_LIST_API,
  jsonApiHeader,
  POST_CLEARINGHOUSE_API,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../constants/ApiConstants';
import { createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';


// export const getMasterData = () => {
//   let fetchUrl = `${GET_MASTERDATABYNAME}`;
//   return (dispatch, getState) => {
//     dispatch(actionCreator(clearingHouseActionTypes.get_masterdata.REQUEST));
//     fetch(fetchUrl, {
//       method: 'post',
//       body: JSON.stringify({ 'masterdata': 'appointmentType,masterstaff,MASTERPATIENTLOCATION' }),
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(clearingHouseActionTypes.get_masterdata.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('error action(clearing house) get_masterdata search --', error);
//       });
//   };
// };

export const getClearingHouseList = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseList.REQUEST));
    fetch(`${GET_CLEARINGHOUSE_LIST_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseList.SUCCESS, response));
        } else {
          dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseList.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error action(clearing house) get_clearing house list --', error);
      });
  };
};

export const getClearingHouseDetails = (clearingHouseId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseDetails.REQUEST));
    fetch(`${GET_CLEARINGHOUSE_DETAILS_API}?id=${clearingHouseId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseDetails.SUCCESS, response));
        } else {
          dispatch(actionCreator(clearingHouseActionTypes.get_clearinghouseDetails.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error action(clearing house) get_clearinghouseDetails --', error);
      });
  };
};

export const saveClearingHouseData = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(clearingHouseActionTypes.save_clearinghouseData.REQUEST));
    fetch(POST_CLEARINGHOUSE_API, {
      method: 'POST',
      body: JSON.stringify(formProps),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.save_clearinghouseData.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.save_clearinghouseData.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error action(clearing house) save_clearing house data --', error);
      });
  };
};

export const deleteClearingHouseData = (id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(clearingHouseActionTypes.delete_clearinghouseData.REQUEST));
    fetch(`${DELETE_CLEARINGHOUSE_API}?id=${id}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200 || response.statusCode === 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.delete_clearinghouseData.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.delete_clearinghouseData.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.delete_clearinghouseData.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error action(clearing house) delete_clearing house data --', error);
      });
  };
};

export const UpdateClearingHouseActiveStatus = (clearingHouseId, IsActivate) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(clearingHouseActionTypes.patch_staff_active_status.REQUEST));
    fetch(`${CLEARINGHOUSE_STATUS_ACTIVATION}?id=${clearingHouseId}&isActive=${IsActivate}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.patch_staff_active_status.SUCCESS, response));
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.patch_staff_active_status.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(clearingHouseActionTypes.patch_staff_active_status.SUCCESS, {}));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
        dispatch(actionCreator(clearingHouseActionTypes.patch_staff_active_status.SUCCESS, {}));
      });
  };

};




// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/clearing-house/actions/ClearingHouseActions.js